import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { reviewHistoryItemSchema } from './review-history-item-schema';

export const getReviewHistoryResponseDataSchema = z.array(reviewHistoryItemSchema);

export type IGetReviewHistoryResponseData = z.infer<typeof getReviewHistoryResponseDataSchema>;

export const getReviewHistoryResponseSchema = createApiResponseSchema(
  getReviewHistoryResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReviewHistoryResponseData>>;

export type IGetReviewHistoryResponse = IAPI<IGetReviewHistoryResponseData>;
